//  Copyright (c) 2019 First Foundry Inc. All rights reserved.

import styled from 'styled-components'
import colors from 'styles/colors'

const FauxLink = styled.span`
    color: ${colors.blue};
`
export default FauxLink

